<template>
  <div>
    <div class="row">
      <h2>API Keys</h2>
    </div>

    <div class="row">
      <span>
        Displays transcribe models details by selecting the API key, and displaying all transcribe models attached with the selected API key.
      </span>
      <br /><br />
    </div>

    <b-row class="d-flex justify-content-center">
      <b-col cols="12" md="6" class="text-center">
        <Multiselect
          @input="getModels()"
          v-model="selectedKey"
          :options="apiList"
          placeholder="Select the API key">
        </Multiselect>
      </b-col>
    </b-row>
    <div v-if="this.rows.length > 0">
      <grid :styles="gridStyle" :cols="cols" :rows="rows" :sort="true" :pagination="pagination" :search="search"></grid>
    </div>

    <div v-if="this.displayLoading" class="d-flex justify-content-center">
      <div>
        <br /><br /><br />
        <br /><br /><br />
        <button class="btn btn-primary" type="button" disabled>
          <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
          Loading data, please wait...
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import apiClient from '@/services/api_client_saas.js'
import Grid from 'gridjs-vue'
import Multiselect from 'vue-multiselect'

export default {
  props: {
  },
  components: {
    Grid,
    Multiselect
  },
  data () {
    return {
      rows: [],
      displayLoading: false,
      requestCompleted: false,
      pagination: true,
      selectedKey: null,
      apiList: [],
      search: true,
      gridStyle: {
        table: {
          border: '3px solid #ccc'
        },
        th: {
          'background-color': 'rgba(0, 0, 0, 0.1)',
          color: '#000',
          'border-bottom': '3px solid #ccc',
          'text-align': 'center'
        },
        td: {
          'text-align': 'center'
        }
      },
      cols: [
        {
          name: 'Lexicon ID',
          formatter: (cell, row) => {
            return this.$gridjs.html('<span>' + cell + '</span>')
          }
        },
        {
          name: 'Model ID',
          formatter: (cell, row) => {
            return this.$gridjs.html('<span>' + cell + '</span>')
          }
        }
      ]
    }
  },
  mounted: function () {
    const apiKeys = this.$store.state.user.apps
    for (let i = 0; i < apiKeys.length; i++) {
      this.apiList.push(apiKeys[i].api_key)
    }
  },
  methods: {
    getModels: function () {
      if (!this.selectedKey || !this.selectedKey.trim()) {
        return
      }

      this.displayLoading = true
      apiClient.get('/api/lexicon/transcribe-models-list-key/' + this.selectedKey).then((response) => {
        for (let i = 0; i < response.data.length; i++) {
          this.rows.push([
            /*
            response.data[i].name,
            response.data[i].features ? response.data[i].features.join(', ') : '<font color="red">Features list is not availale</font>',
            response.data[i].description
            */
            response.data[i].lexicon_id,
            response.data[i].model_id
          ])
        }

        this.requestCompleted = true
        this.displayLoading = false
      }).catch((error) => {
        console.log(error)
        if (error.response) {
          console.log(error.response.data)
        }
      })
    }
  }
}
</script>
